import React from "react";
import styled, { css } from "styled-components";

/**
 * Carte de base de la charte "Pilotage RH".
 *
 * <Card>
 *   <CardTitle>Titre de la carte</CardTitle>
 *   <CardBody centered>...</CardBody>
 * </Card>
 */
const Card = ({ children, column = false, ...props }) => {
    return (
        <Wrapper $column={column} {...props}>
            {children}
        </Wrapper>
    );
};

export default Card;

const Wrapper = styled.div`
    background: var(--prh-card);
    border-radius: var(--prh-radius);
    box-shadow: var(--prh-shadow);
    border: 1px solid var(--prh-line);
    padding: 16px 17px 15px;
    position: relative;
    ${({ $column }) =>
        $column &&
        css`
            display: flex;
            flex-direction: column;
        `}
`;

/** Titre (h3) d'une carte graphique */
export const CardTitle = styled.h3`
    font-size: var(--prh-font-lg);
    font-weight: 600;
    margin: 0 0 13px;
    display: flex;
    align-items: center;
    gap: var(--prh-space-sm);
    color: var(--prh-ink);
    padding-right: 28px;
`;

/** Libellé (petit texte gris) d'une carte KPI */
export const CardLabel = styled.div`
    font-size: var(--prh-font-md);
    color: var(--prh-muted);
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 9px;
    padding-right: 22px;
    line-height: 1.35;
`;

/** Grande valeur d'une carte KPI */
export const CardValue = styled.div`
    font-size: var(--prh-font-kpi);
    font-weight: 600;
    line-height: 1.1;
    color: var(--prh-ink);
`;

export const CardUnit = styled.span`
    font-size: var(--prh-font-base);
    font-weight: 400;
    color: var(--prh-muted-2);
    margin-left: 5px;
`;

export const CardSub = styled.div`
    font-size: 13px;
    color: var(--prh-muted-2);
    margin-top: 6px;
`;

/**
 * Corps de carte : occupe l'espace restant et centre verticalement son contenu.
 * `centered` : centre aussi horizontalement (donuts).
 */
export const CardBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: ${({ $end }) => ($end ? "flex-end" : "center")};
    ${({ $gap }) =>
        $gap &&
        css`
            gap: ${$gap};
        `}
`;

export const CenterRow = styled.div`
    display: flex;
    justify-content: center;
`;
